import axios from "axios";

export function getAffiliateSummary(attendeeId: number) {
  return axios(`/api/Attendee/${attendeeId}/summary`, {
    method: "GET"
  });
}
